import React from 'react';

export function CustomNextArrow(props : any) {
    const { className, style, onClick } = props;
    let classes = 'chevron right circular inverted large icon slick-custom-right-icon';
    if(className.includes('slick-disabled')){
        classes = classes.concat(' slick-custom-disabled-icon');
    }
    return (
        <i aria-hidden="true" onClick={onClick} style={{ ...style}}
        className={classes} />
    );
  }
  
  export function CustomPrevArrow(props  :any) {
    const { className, style, onClick } = props;
    let classes = 'chevron left circular inverted large icon slick-custom-left-icon';
    if(className.includes('slick-disabled')){
        classes = classes.concat(' slick-custom-disabled-icon');
    }
    return (
        <i aria-hidden="true" onClick={onClick} style={{ ...style}} 
        className={classes} />
    );
  }

 export const slider_settings : any = {
    dots: false,
    infinite: false,
    swipe: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    className:'custom-inner-slider',
    draggable:false,
    focusOnSelect: false,
    accessibility:false,
    centerMode: false,
    autoPlay:false,
    lazyLoad:true,
    adaptiveHeight: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  };
